import { defineActions } from '@noven-prime/lattice-core';
import { defaultPortalSettings } from '@denise-augusta/domain';
import { getPortalSettingsStore } from './store.js';
/**
 * Portal Settings capability actions — admin only.
 */
export const portalSettingsActions = defineActions({
    getPortalSettings: {
        id: 'getPortalSettings',
        name: 'Get Portal Settings',
        description: 'Get the portal settings (LLM configuration, …)',
        params: { type: 'object', properties: {} },
        result: { type: 'object' },
        access: {
            scopes: ['root', 'admin'],
        },
        execute: async (_params, _context) => {
            const settings = await getPortalSettingsStore().load();
            return settings ?? defaultPortalSettings;
        },
    },
    updatePortalSettings: {
        id: 'updatePortalSettings',
        name: 'Update Portal Settings',
        description: 'Persist portal settings to the private portal container',
        params: {
            type: 'object',
            properties: {
                settings: { type: 'object', description: 'The full PortalSettings document' },
            },
            required: ['settings'],
        },
        result: { type: 'object' },
        access: {
            scopes: ['root', 'admin'],
        },
        execute: async (params, _context) => {
            const next = {
                ...params.settings,
                updatedAt: new Date().toISOString(),
            };
            await getPortalSettingsStore().save(next);
            return next;
        },
    },
});
//# sourceMappingURL=actions.js.map